import React from 'react';
import { CtaBlock } from '../CtaButton';
import { Accent } from './SectionHeading';
import { systemFlow } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
export function HeroSection() {
  return <section aria-labelledby="hero-heading" className="bg-brand-paper px-5 pb-16 pt-8 lg:px-8 lg:pb-20 lg:pt-12" data-id="element-96" data-mp="16ocn3gcegksh">
      <div className="mx-auto max-w-4xl text-center" data-id="element-97" data-mp="12nizyp6s7a0n">
        <p className="mx-auto inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-[8px] border border-brand-plum/25 bg-white px-4 py-2 font-body text-[10px] font-bold uppercase tracking-[0.18em] text-brand-charcoal/75 sm:text-[11px]" data-id="element-98" data-mp="1zcqm9zf85n5m">
          {systemFlow.map((topic, index) => <React.Fragment key={topic} data-id="element-99" data-mp="1ld8s14j5thov" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" className="text-brand-gold" data-id="element-100" data-mp="ewdkwc8o0lre">
                  •
                </span>}
              <span data-id="element-101" data-mp="9x0whn25b6mp">{topic}</span>
            </React.Fragment>)}
        </p>

        <h1 id="hero-heading" className="mt-5 font-display text-[2.6rem] font-bold leading-[1.02] tracking-[-0.015em] text-brand-charcoal sm:text-[3.4rem] lg:text-[4.25rem]" data-id="element-102" data-mp="38ftdb87l9vmz">
          Your Next Makeup Class Could Be <Accent data-id="element-103" data-mp="2zev9apx5ho4e">Ready in Minutes.</Accent>
          <span className="mt-2 block font-body text-[13px] font-bold uppercase tracking-[0.18em] text-brand-plum sm:text-[15px]" data-id="element-104" data-mp="34epvwh9w7rjn">
            For Makeup Instructors & Educators
          </span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-[16px] font-semibold leading-relaxed text-brand-charcoal sm:text-[17px]" data-id="element-105" data-mp="2uga6ciqikqc9">
          Stop spending hours planning lessons, exercises and student activities from scratch.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[15px] leading-relaxed text-brand-charcoal/70 sm:text-[16px]" data-id="element-106" data-mp="2krs7w85pivbs">
          Get lesson structures, technique guides, student exercises, assessments and instructor resources —
          organized in one professional teaching system.
        </p>
      </div>

      <img src={MOCKUP_URL} alt="Makeup Instructor Ready — the six core volumes with real inside pages on a tablet, laptop and phone" width={1536} height={1024} loading="eager" decoding="async" className="mx-auto mt-8 block w-full max-w-[1000px] object-contain" style={{
      filter: 'drop-shadow(0 30px 36px rgba(59, 27, 87, 0.18))'
    }} data-id="element-107" data-mp="havm2w91r642" />

      <CtaBlock label="Yes! I Want My Classes Ready" note="6 Core Volumes + 5 Extra Bonuses • Instant Digital Access" className="mt-8" data-id="element-108" data-mp="107et9g0aijxz" />
    </section>;
}